<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <router-link class="btn btn-sm" :to="{ name: 'RoutingGroupList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link>
                Routing Peer Group
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Routing Peer Group</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="RoutingRouteMap">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">

                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="peer_group_name"
                        name="peer_group_name"
                        v-bind:class="{ 'has-error': errors.has('peer_group_name') }"
                        v-validate="{ required: true, regex: /^[A-Za-z_]+$/}"
                        v-model="value.peer_group_name"
                        :readonly="is_edit"
                        class="form-control peer_group_name"
                        placeholder="Name"
                      />
                      <div class="help text-danger" v-show="errors.has('peer_group_name')">
                        {{ `The name should only contains alphabet and underscrore.` }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Remote AS</label>
                      <input
                        type="text"
                        id="remote_as"
                        name="remote as"
                        v-validate="'required|numeric|max:7'"
                        :readonly="is_edit"
                        v-bind:class="{ 'has-error': errors.has('remote_as') }"
                        v-model="value.remote_as"
                        class="form-control remote_as"
                        placeholder="remote as"
                      />
                      <div class="help text-danger" v-show="errors.has('remote as')">
                        {{ errors.first("remote as") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Update Source</label>
                      <input
                        type="text"
                        id="update_source"
                        name="update source"
                        v-validate="'required|ip'"
                        v-bind:class="{ 'has-error': errors.has('update_source') }"
                        v-model="value.update_source"
                        class="form-control update_source"
                        placeholder="update source"
                      />
                      <div class="help text-danger" v-show="errors.has('update source')">
                        {{ errors.first("update source") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Route Map In</label>
                      <multiselect
                        v-model="value.route_map_in_id"
                        :options="Object.keys(pre.routeMaps)"
                        :custom-label="opt => pre.routeMaps[opt]"
                        placeholder="Select Route Map"
                        :searchable="true"
                        :multiple="false"
                        id="route_map_in_id"
                        v-bind:class="{ 'has-error': errors.has('route_map_in_id') }"
                        v-validate="'required'"
                        name="route_map_in_id"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('route_map_in_id')"
                      >
                        {{ errors.first('route_map_in_id') }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Route Map Out</label>
                      <multiselect
                        v-model="value.route_map_out_id"
                        :options="Object.keys(pre.routeMaps)"
                        :custom-label="opt => pre.routeMaps[opt]"
                        placeholder="Select Route Map"
                        :searchable="true"
                        :multiple="false"
                        id="route_map_out_id"
                        v-bind:class="{ 'has-error': errors.has('route_map_out_id') }"
                        v-validate="'required'"
                        name="route_map_out_id"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('route_map_out_id')"
                      >
                        {{ errors.first('route_map_out_id') }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Hold Time</label>
                      <input
                        type="text"
                        id="hold_time"
                        name="hold time"
                        v-validate="{required: true, max_value: 65535, min_value: 1, is: (value.hold_time % 3 !== 0)}"
                        v-bind:class="{ 'has-error': errors.has('hold_time') }"
                        v-model="value.hold_time"
                        class="form-control hold_time"
                        placeholder="hold time"
                      />
                      <div class="help text-danger" v-show="errors.has('hold time')">
                        {{ errors.first("hold time") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Force Next Hop Self</label>
                      <multiselect
                      v-model="value.force_nexthop_self"
                      :options="Object.keys(pre.forceNextHopSelf)"
                      :custom-label="opt => pre.forceNextHopSelf[opt]"
                      placeholder="Select Force Next Hop Self"
                      :searchable="true"
                      :multiple="false"
                      id="force_nexthop_self"
                      v-bind:class="{
                          'has-error': errors.has('force_nexthop_self'),
                      }"
                      name="force_nexthop_self"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('force_nexthop_self')">
                      {{ errors.first("force_nexthop_self") }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" v-if="!is_edit" class="btn">Submit</button>
                <button type="submit" v-if="is_edit" class="btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "RoutingPeerGroupForm",
  metaInfo: {
    title: "Routing Peer Group | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
    },
    pre: {
      routeMaps: {},
      forceNextHopSelf: { 1: 'Yes', 0: 'No' }
    },
  }),

  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/routing_peer_groups";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/routing_peer_groups/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: 'RoutingGroupList', params: { tab: 'peer-group' } });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/routing_peer_groups/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      const _this = this
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }
      await this.getRouteMaps()
        .then((response) => {
          _this.pre.routeMaps = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    getRouteMaps: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get_route_maps";
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
